<template>
    <FormulateForm v-model="formData" :errors="$page.props.errors" novalidate @submit="handleSubmit">
        <div class="form_field">
            <IconEmail class="form_field_prefix" />
            <FormulateInput
                type="email"
                name="email"
                validation="required|email"
                placeholder="Email"
            />
        </div>
        <FormulateInput
            type="submit"
            label="send password reset link"
            class="submitButton"
        />
    </FormulateForm>
</template>

<script setup lang="ts">
import route from 'ziggy-js';
import { router } from '@inertiajs/vue2';
import IconEmail from '@/components/icons/IconEmail.vue';
import type { ResetPasswordRequestFormData, Incomplete } from '../types';
import { reactive } from 'vue';

const formData = reactive<Incomplete<ResetPasswordRequestFormData>>({
    email: null,
});

function handleSubmit(data: ResetPasswordRequestFormData) {
    router.post(route('password.email'), data);
}
</script>
